import React from "react";
var PlaylistTitleError;
(function (PlaylistTitleError) {
    PlaylistTitleError["Empty"] = "empty";
})(PlaylistTitleError || (PlaylistTitleError = {}));
var mapErrorToMessage = function (key) {
    var _a;
    if (!key)
        return "";
    return (_a = {}, _a[PlaylistTitleError.Empty] = "Введите название", _a)[key];
};
export var usePlaylistTitleEdit = function (initial) {
    var _a = React.useState(initial), title = _a[0], setTitle = _a[1];
    var _b = React.useState(null), error = _b[0], setError = _b[1];
    var validate = function () {
        var key = null;
        if (title.length === 0) {
            key = PlaylistTitleError.Empty;
        }
        setError(key);
        return key === null;
    };
    return {
        value: title,
        set: setTitle,
        error: {
            value: Boolean(error),
            set: setError,
            key: error,
            message: mapErrorToMessage(error),
        },
        validate: validate,
    };
};
